module.exports = __webpack_public_path__ + "static/4105-40a331bdbbd562cda2383f1be5ebeaab.png";